export enum ImportEmlState {
  Uploaded = 1,
  InProgress = 2,
  Imported = 3,
  ImportError = 4,
  UploadError = 5,
}
